import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { PaletteColor, Radius, Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type BadgeProps = Omit<HTMLArkProps<'span'>, 'color'> & {
	variant?: 'soft' | 'solid' | 'outline' | 'surface';
	size?: Scale3;
	color?: PaletteColor;
	radius?: Radius;
};

function Badge({
	className,
	variant = 'soft',
	size = '1',
	color = 'gray',
	radius,
	...props
}: BadgeProps) {
	return (
		<ark.span
			data-slot="badge"
			data-variant={variant}
			data-size={size}
			data-accent-color={color}
			data-radius={radius}
			className={cn('pt-badge', className)}
			{...props}
		/>
	);
}

export { Badge, type BadgeProps };
